// C2 · Collection page (sections/c2-collection-grid.liquid).
// 1. Colour squares on a card: show that colour's photo, its name, and point the card's links
//    to that colour's variant. No page load.
// 2. Filters and sort: applied as soon as a box is ticked or a sort is picked (plain GET form,
//    so every filtered page also works without JavaScript).
(() => {
  if (window.c2CollectionReady) return;
  window.c2CollectionReady = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-c2cl-sw]');
    if (!btn) return;
    const card = btn.closest('[data-c2cl-card]');
    const img = card.querySelector('[data-c2cl-main] img');
    if (img && btn.dataset.src) {
      // a photo not loaded yet (snippet c2-lazy) must not get its own photo back afterwards
      img.removeAttribute('data-c2-lazy');
      delete img.dataset.c2Src;
      delete img.dataset.c2Srcset;
      img.removeAttribute('srcset');
      img.src = btn.dataset.src;
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
      img.alt = btn.dataset.alt || img.alt;
    }
    card.querySelectorAll('[data-c2cl-link]').forEach((a) => { a.href = btn.dataset.url; });
    const name = card.querySelector('[data-c2cl-name]');
    if (name) name.textContent = btn.getAttribute('aria-label');
    card.querySelectorAll('[data-c2cl-sw]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
  });

  // Photos of the other colours start loading when the visitor points at a card.
  document.addEventListener('pointerover', (e) => {
    const card = e.target.closest && e.target.closest('[data-c2cl-card]:not([data-c2cl-warm])');
    if (!card) return;
    card.setAttribute('data-c2cl-warm', '');
    card.querySelectorAll('[data-c2cl-sw]').forEach((b) => { if (b.dataset.src) new Image().src = b.dataset.src; });
  });

  // The number next to the collection title (C2 · Page heading) = the products the grid really shows.
  const syncCount = () => {
    const shown = document.querySelector('[data-c2cl-shown]');
    if (!shown) return;
    document.querySelectorAll('.c2-ph__main[data-count]').forEach((el) => { el.dataset.count = shown.dataset.c2clShown; });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCount); else syncCount();

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-c2cl-form]');
    if (!form) return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  // One filter panel open at a time; a click outside closes it.
  document.addEventListener('toggle', (e) => {
    if (!e.target.matches || !e.target.matches('[data-c2cl-drop]') || !e.target.open) return;
    document.querySelectorAll('[data-c2cl-drop][open]').forEach((d) => { if (d !== e.target) d.open = false; });
  }, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-c2cl-drop]')) return;
    document.querySelectorAll('[data-c2cl-drop][open]').forEach((d) => { d.open = false; });
  });
})();
